
type ResourceQuestionHeaderProps = {   
  title: string;
  pronoun?: string;
  searchTerm: string;
  searchPlaceholder?: string;
  onSearchChange: (value: string) => void;
  onSearch: () => void;
}

export function ResourceQuestionHeader({ 
  title, 
  pronoun = "os",
  searchTerm,
  searchPlaceholder = "Pesquisar...",
  onSearchChange,
  onSearch
}: ResourceQuestionHeaderProps) {
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-0">
        <h2 className="h5 fw-semibold text-dark mb-0">
          {title}
        </h2>
        <div className="position-relative" style={{ width: '250px' }}>
          <input 
            type="text"
            className="form-control ps-5 pe-3 py-2 border border-secondary-subtle rounded-3"
            placeholder={searchPlaceholder}
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && onSearch()}
            style={{ 
              fontSize: '14px',
              outline: 'none',
              boxShadow: 'none'
            }}
          />
          <i 
            className="bi bi-search position-absolute text-muted"
            style={{
              left: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: '16px'
            }}
          ></i>
        </div>
      </div>
    </div>
  );
}
